import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';

const ExtractSubjectsDialog = (props) => {
    const [dialogVisible, setDialogVisible] = useState(false);
    const [step, setStep] = useState('START');
    const [errorMessages, setErrorMessages] = useState(null);

    const toast = useRef(null);
    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setDialogVisible(props.visible);
    }, [props.visible]);

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        if (step === 'SUCCESS') {
            if (typeof props.afterSave === 'function') {
                props.afterSave();
            }
        }
        setDialogVisible(false);
    };

    const extractSubjects = () => {
        competitionService
            .extractSubjects(props.competition?.id)
            .then(() => {
                setStep('SUCCESS');
                //toast.current.show({ severity: 'success', summary: translatedMessage('generic.save.success') });
            })
            .catch((errors) => {
                setStep('ERROR');
                setErrorMessages(errors);
            });
    };

    const subjectDialogFooter = (
        <>
            {step === 'START' && <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />}
            {step === 'START' && <Button label={translatedMessage('competition.subjectProposals.extract')} icon="pi pi-save" className="p-button-text" onClick={extractSubjects} />}
            {step === 'ERROR' && <Button label={translatedMessage('generic.close')} icon="pi pi-save" className="p-button-text" onClick={hideDialog} />}
            {step === 'SUCCESS' && <Button label={translatedMessage('generic.close')} icon="pi pi-save" className="p-button-text" onClick={hideDialog} />}
        </>
    );

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={dialogVisible} style={{ width: '600px' }} header={translatedMessage('competition.extractSubjects.title')} modal className="p-fluid" footer={subjectDialogFooter} onHide={hideDialog}>
                <div className="w-full grid pcn-data-view-panel">
                    {step === 'START' && (
                        <>
                            <div className="col-1 flex align-items-center">
                                <Button icon="pi pi-exclamation-circle" className="p-button-rounded p-button-info p-button-text" />
                            </div>
                            <div className="col-11 flex align-items-center">
                                <div className="w-full grid pcn-data-view-panel">
                                    <div className="col-12 flex align-items-center">
                                        <b>{translatedMessage('competition.extractSubjects.question')}</b>
                                    </div>
                                    <div className="col-12 flex align-items-center">{translatedMessage('competition.extractSubjects.content')}</div>
                                </div>
                            </div>
                        </>
                    )}
                    {step === 'ERROR' && (
                        <div className="col-12 flex align-items-center">
                            <Button icon="pi pi-times" className="p-button-rounded p-button-danger p-button-text" />

                            <ul>
                                {Array.isArray(errorMessages) &&
                                    errorMessages?.map((item, index) => (
                                        <li key={index} className="mb-2">
                                            {props?.translate ? translatedMessage(item) : item}
                                        </li>
                                    ))}
                                {!Array.isArray(errorMessages) && (
                                    <li key={1} className="mb-2">
                                        {props?.translate ? translatedMessage(errorMessages) : errorMessages}
                                    </li>
                                )}
                            </ul>
                        </div>
                    )}
                    {step === 'SUCCESS' && (
                        <>
                            <div className="col-12 flex align-items-center">
                                <Button icon="pi pi-check" className="p-button-rounded p-button-text" />
                                {translatedMessage('competition.extractSubjects.success.message')}
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default ExtractSubjectsDialog;
